<template>
    <div>
        <div v-if="value && show">
            <video class="video" :src="value" ref="player" controls v-if="mode === 'video'" @play="getdetail" />
            <img class="video" :src="value" v-else-if="mode === 'image'" />
            <audio class="video" :src="value" ref="player" controls v-else-if="mode === 'mp3'" />
            <!-- <a-alert :message="fileName+'上传成功'" type="success" show-icon v-else /> -->
            <!-- <p v-else><a-icon type="file-zip" class="zipIcon" />{{fileName}}文件已存在，点击下方进行替换</p> -->
        </div>
        <a-upload :accept="accept" :name="fileType" :multiple="false" :fileList="fileList" action="http://127.0.0.1:9000"
            :customRequest="upload" @change="handleUploadExplainVideo">
            <a-button type="danger" icon="upload">{{ buttonText }}</a-button>
            <a-button v-if="deleteUpdate&&value"  style="margin-left: 15px;" type="danger" icon="delete" @click.stop="deleteVideo">删除视频</a-button>
        </a-upload>
    </div>
</template>


<script>
import axios from "axios";

export default {
    props: {
        value: {
            type: String
        },
        mode: {
            type: String,
            default: "video"
        },
        buttonText: {
            type: String,
            default: "上传"
        },
        show: {
            type: Boolean,
            default: true
        },
        fileType: {
            type: String,
            default: 'file'
        },
        deleteUpdate:{
            type:Boolean,
            default:false
        }
    },
    data() {
        return {
            fileList: [],
            loading: false,
            fileName: ''
        };
    },
    methods: {
        getdetail() {
            console.info("duration:", this.$refs);
        },
        handleUploadExplainVideo(info) {
            this.fileList = [...info.fileList];
        },
        deleteVideo(){
            this.$emit("input", '');
        },
        async upload(info) {
            const file = info.file;
            const data = { filename: file.name };
            this.fileName = file.name;
            const res = await axios.post(
                "https://ycsx.tk123.top/admin/oss/get_upload_sign",
                data, {
                headers: {
                    'Authorization': localStorage.getItem('token')
                }
            }
            );
            const oss = res.data.data;
            const formdata = new FormData();
            formdata.append("key", oss.key);
            formdata.append("policy", oss.policy);
            formdata.append("OSSAccessKeyId", oss.id);
            formdata.append("success_action_status", 200);
            formdata.append("signature", oss.signature);
            formdata.append("file", file);
            let { fileList } = this;
            await axios.post(oss.upload_url, formdata, {
                headers: { "Content-Type": "multipart/form-data" },
                onUploadProgress(e) {
                    fileList.forEach(item => {
                        if (file.uid === item.uid) {
                            const percent = parseInt(
                                (e.loaded / e.total) * 100
                            );
                            item.percent = percent;
                            if (percent >= 100) {
                                item.status = "success";
                            }
                        }
                    });
                }
            });

            setTimeout(() => {
                this.fileList = [];
            }, 2000);
            const videoUrl = oss.upload_url + "/" + oss.key;
            this.$emit("input", videoUrl);
        }
    },
    computed: {
        accept() {
            let accept = "*";
            if (this.mode === "image") {
                accept = ".png, .jpg";
            } else if (this.mode === "video") {
                accept = ".mp4";
            }
            else if (this.mode === "mp3") {
                accept = ".mp3";
            }
            return accept;
        }
    }
};
</script>

<style lang="less" scoped>
.video {
    width: 100%;
    margin-bottom: 1rem;
}

.zipIcon {
    padding-right: 1rem;
    // color: #ffe493;
    font-size: 1.2rem;
}
</style>
